import { render, staticRenderFns } from "./TimeSlotMessage.vue?vue&type=template&id=1f86658c&scoped=true&"
import script from "./TimeSlotMessage.vue?vue&type=script&lang=js&"
export * from "./TimeSlotMessage.vue?vue&type=script&lang=js&"
import style0 from "./TimeSlotMessage.vue?vue&type=style&index=0&id=1f86658c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f86658c",
  null
  
)

export default component.exports